import styled from 'styled-components';

import {FONT_FAMILIES} from '../../const';

const BoldText = styled.span`
  font-family: ${FONT_FAMILIES.BODY};
  font-weight: bold;
`;

export default BoldText;
